export enum OrderColorCode {
  Default = 'default',
  Blue = 'blue',
  Red = 'red',
  Green = 'green',
}
